export default class StaffSelectService {
  constructor() {}
  // クラスのメンバ変数として保存するプロパティを定義

  staffCode: string = "";
  staffName: string = "";

  async setStaffSelect(
    staffCode: string | null | undefined,
    staffName: string | null | undefined,
  ): Promise<boolean> {
    try {
      // データをクラスのメンバ変数に保存
      if (staffCode && staffName) {
        this.staffCode = staffCode;
        this.staffName = staffName;
        sessionStorage.setItem("staffCode", staffCode);
        sessionStorage.setItem("staffName", staffName);
      } else {
        this.staffCode = staffCode ?? "";
        this.staffName = staffName ?? "";
        this.clearStoredData();
      }
      return true;
    } catch (error) {
      console.error("Failed to fetch company data:", error);
      this.clearStoredData();
      return false;
    }
  }

  // メンバ変数からデータを取得するためのゲッターメソッド
  getStaffSelect() {
    return {
      staffCode: sessionStorage.getItem("staffCode"),
      staffName: sessionStorage.getItem("staffName"),
    };
  }

  clearStoredData() {
    this.staffCode = "";
    sessionStorage.removeItem("staffCode");
    this.staffName = "";
    sessionStorage.removeItem("staffName");
  }
}

import { ref } from "vue";

type SelectedActionStaffSelectCallback = () => void;

export function useStaffSelect() {
  const StaffSelectId: string = "StaffSelectId";
  const isModalStaffSelectVisible = ref(false);
  let selectedActionStaffSelectCallback: SelectedActionStaffSelectCallback | null =
    null;

  async function showStaffSelect(
    callback: SelectedActionStaffSelectCallback | null,
  ) {
    isModalStaffSelectVisible.value = true;
    selectedActionStaffSelectCallback = callback;
  }

  async function closeModalStaffSelect(): Promise<void> {
    isModalStaffSelectVisible.value = false;
  }

  async function selectedActionStaffSelect(): Promise<void> {
    if (selectedActionStaffSelectCallback) {
      selectedActionStaffSelectCallback(); // コールバックにユーザーを渡す
    }
    await closeModalStaffSelect();
  }

  function cancelActionStaffSelect(): void {
    closeModalStaffSelect();
  }

  return {
    StaffSelectId,
    isModalStaffSelectVisible,
    showStaffSelect,
    closeModalStaffSelect,
    cancelActionStaffSelect,
    selectedActionStaffSelect,
  };
}
